import Vue from 'vue';
export default {
  inject: ['load'],
  data() {
    return {
      allRecentCalls: [],
      callLocation: null,
      gettingCallLocation: false,
    };
  },
  methods: {
    showError: function () {
      this.snackText = this.$store.state.callModule.error;
      this.showErrorAlert(this.snackText);
    },
    getAllRecentCallsFunction: function (callerId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllRecentCalls', callerId).then(() => {
        if (this.$store.state.callModule.successFlag) {
          this.allRecentCalls = [];
          let temp = this.$store.state.callModule.allRecentCalls;
          for (let i = 0; i < temp.length; i++) {
            let date = '-';
            let time = '-';
            if (temp[i].callDate) {
              date = Vue.moment(temp[i].callDate).format('jYYYY/jM/jD');
              time = Vue.moment(temp[i].callDate).format('HH:mm:ss');
            }
            const userInfo = temp[i]?.callDestinations[0]?.user;
            const operatorFullName =
              userInfo?.firstName && userInfo?.lastName
                ? `${userInfo?.firstName} ${userInfo?.lastName}`
                : userInfo?.userName;
            this.allRecentCalls.push({
              id: temp[i].id,
              result: temp[i].lastCallTag ? temp[i].lastCallTag : '-',
              date: date,
              time: time,
              operator: operatorFullName,
            });
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.callModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getAllRecentCallsFunction(callerId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.callModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllRecentCallsFunction(callerId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getCallLocation: function (uniqueId) {
      const params = {
        uniqueId,
      };
      this.gettingCallLocation = true;
      this.$store
        .dispatch('getCallLocationDispatch', params)
        .then(() => {
          if (this.$store.state.callModule.successFlag) {
            const data = this.$store.state.callModule.callLocation;
            //دیتا فیک
            // const data = {
            //   "latitude": 38.5648,
            //   "longitude": 45.0212,
            //   "address": "تهران، میدان آزادی، خیابان آزادی، پلاک ۱۲۳",
            //   "isSuccessful": true,
            //   "isMobileLocation": true,
            //   "callerId": "CALL-2026-001",
            //   "status": "success",
            //   "receiveDateTime": "2026-07-04T14:30:00"
            // };
            // console.log("A data :", data);
            this.callLocation = data;
            this.showBTSLocation?.();
          } else {
            if (this.$store.state.callModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getCallLocation(uniqueId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.callModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getCallLocation(uniqueId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => (this.gettingCallLocation = false));
    },
    playAudioFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('listenToCallDispatch', id).then(() => {
        if (this.$store.state.callModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.callModule.file) {
            const url = window.URL.createObjectURL(new Blob([this.$store.state.callModule.file]));
            // this.recordFile = url;
            // this.player = true;
            try {
              this.$root.$refs.Home.recordFileHome = url;
              this.$root.$refs.Home.playerHome = true;
            } catch (error) {
              console.log('A Error accessing Home component:', error);
            }
          } else {
            this.snackText = 'فایل صوتی جهت پخش وجود ندارد';
            this.$refs.snackRef.snackModel = true;
            this.snackColor = '#FF5252';
            this.snakIcon = 'mdi-information';
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.callModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.playAudioFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.callModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.playAudioFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    downloadAudioFunction: function (id, fileName) {
      if (!this.load.val) {
        this.load.val = true;
      }

      this.$store.dispatch('downloadCallDispatch', id).then(() => {
        if (this.$store.state.callModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.callModule.file) {
            const url = window.URL.createObjectURL(new Blob([this.$store.state.callModule.file]));
            const link = document.createElement('a');
            link.href = url;
            var today = new Date();
            var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
            fileName = `${fileName}-${date}`;
            link.setAttribute('download', fileName + '.mp3');
            document.body.appendChild(link);
            link.click();
          } else {
            this.snackText = 'فایل صوتی جهت دانلود وجود ندارد';
            this.$refs.snackRef.snackModel = true;
            this.snackColor = '#FF5252';
            this.snakIcon = 'mdi-information';
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.callModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.downloadAudioFunction(id, fileName);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.callModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.downloadAudioFunction(id, fileName);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    playAudioMissionFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('listenToCallFileDispatch', id).then(() => {
        if (this.$store.state.callModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.callModule.file) {
            const url = window.URL.createObjectURL(new Blob([this.$store.state.callModule.file]));
            // this.recordFile = url;
            // this.player = true;
            try {
              this.$root.$refs.Home.recordFileHome = url;
              this.$root.$refs.Home.playerHome = true;
            } catch (error) {
              console.log('A Error accessing Home component:', error);
            }
          } else {
            this.showErrorAlert('فایل صوتی جهت پخش وجود ندارد');
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.callModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.playAudioFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.callModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.playAudioFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    downloadAudioMissionFunction: function (id, fileName) {
      if (!this.load.val) {
        this.load.val = true;
      }

      this.$store.dispatch('downloadCallFileMissionDispatch', id).then(() => {
        if (this.$store.state.callModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.callModule.file) {
            const url = window.URL.createObjectURL(new Blob([this.$store.state.callModule.file]));
            const link = document.createElement('a');
            link.href = url;
            var today = new Date();
            var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
            fileName = `${fileName}-${date}`;
            link.setAttribute('download', fileName + '.mp3');
            document.body.appendChild(link);
            link.click();
          } else {
            this.snackText = 'فایل صوتی جهت دانلود وجود ندارد';
            this.$refs.snackRef.snackModel = true;
            this.snackColor = '#FF5252';
            this.snakIcon = 'mdi-information';
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.callModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.downloadAudioFunction(id, fileName);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.callModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.downloadAudioFunction(id, fileName);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    callToCodeFunction: function (data) {
      this.$store.dispatch('callToCode', data).then(() => {
        if (this.$store.state.callModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.$store.state.callModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.callToCodeFunction(data);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.callModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.callToCodeFunction(data);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    callToPatientFunction: function (data) {
      this.$store.dispatch('callToPatient', data).then(() => {
        if (this.$store.state.callModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          // this.snackText = 'تماس با موفقیت انجام شد';
          // this.$refs.snackRef.snackModel = true;
          // this.snackColor = '#00ff66';
          // this.snakIcon = 'mdi-information';
        } else {
          if (this.$store.state.callModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.callToPatientFunction(data);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.callModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.callToPatientFunction(data);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    callToInternalFunction: function (data) {
      this.$store.dispatch('callToInternal', data).then(() => {
        if (this.$store.state.callModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.$store.state.callModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.callToInternalFunction(data);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.callModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.callToInternalFunction(data);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    callToHospitalFunction: function (data) {
      this.$store.dispatch('callToHospital', data).then(() => {
        if (this.$store.state.callModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.$store.state.callModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.callToHospitalFunction(data);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.callModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.callToHospitalFunction(data);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    callToOtherOrganizationFunction: function (data) {
      this.$store.dispatch('callToOrganization', data).then(() => {
        if (this.$store.state.callModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.$store.state.callModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.callToOtherOrganizationFunction(data);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.callModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.callToOtherOrganizationFunction(data);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    callToCustomNumber: function (data) {
      this.$store.dispatch('callToCustomNumberDispatch', data).then(() => {
        if (this.$store.state.callModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.$store.state.callModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.callToCustomNumber(data);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.callModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.callToCustomNumber(data);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    // showError: function () {
    //   this.snackText = this.$store.state.callModule.error;
    //   this.$refs.snackRef.snackModel = true;
    //   this.snackColor = "#FF5252";
    //   this.snakIcon = "mdi-information";
    // },
  },
};
